export default "__VITE_ASSET__e12f514c__"